import { HttpErrorResponse } from '@angular/common/http';

/**
 * Error code returned by the API when the user has not accepted the actual
 * version of the user agreement.
 */
export const USER_AGREEMENT_NOT_ACCEPTED_CODE = 'user_agreement_not_accepted';

/**
 * Http error thrown instead of the original one when a private request has been
 * rejected because the user agreement has not been accepted yet.
 *
 * It keeps the original response shape so the existing error handling code
 * keeps working, but allows an `instanceof` check to suppress error screens,
 * toasts and modals for this particular case.
 */
export class UserAgreementNotAcceptedError extends HttpErrorResponse {
  constructor(error: HttpErrorResponse) {
    super({
      error: error.error,
      headers: error.headers,
      status: error.status,
      statusText: error.statusText,
      url: error.url || undefined,
    });
  }
}

/**
 * Whether the given error means that the user agreement has not been accepted.
 */
export function isUserAgreementNotAcceptedError(error: unknown): boolean {
  if (error instanceof UserAgreementNotAcceptedError) {
    return true;
  }

  if (!(error instanceof HttpErrorResponse) || error.status !== 403) {
    return false;
  }

  return error.error?.code === USER_AGREEMENT_NOT_ACCEPTED_CODE;
}
